import React, {useEffect, useMemo, useState} from 'react';
import {useCommand} from 'hooks';
import {BaseDialog} from 'components/Dialogs/BaseDialog';
import {useDialogState} from 'components/Dialogs';
import {IDialogContentProps} from 'components/FluentUICompat';
import {useTranslation} from 'react-i18next';

interface AggregateDialogProps {
	buttonKey: string;
	buttonText: string;
	buttonPriority?: number;
	buttonHidden: boolean;
	dialogTitle: string;
	dialogText: string;
	handleConfirm: () => void;
}
export const ConfirmAggregateDialog: React.FC<AggregateDialogProps> = ({
	buttonKey,
	buttonText,
	buttonPriority,
	buttonHidden,
	dialogTitle,
	dialogText,
	handleConfirm,
}) => {
	const {t} = useTranslation('components/dialogs', {
		keyPrefix: 'ConfirmUpdateDialog',
	});

	const [{hidden, onDismiss}, showAggregateDialog, hideAggregateDialog] =
		useDialogState();

	useCommand(
		{
			key: buttonKey,
			text: buttonText,
			iconProps: {iconName: 'Sync'},
			priority: buttonPriority ?? 5,
			onClick: showAggregateDialog,
			hidden: buttonHidden,
		},
		[],
	);

	const dialogContentProps: IDialogContentProps = {
		title: dialogTitle,
		subText: dialogText,
	};
	const onConfirm = () => {
		handleConfirm();
		hideAggregateDialog();
	};
	return (
		<BaseDialog
			hidden={hidden}
			onConfirm={onConfirm}
			onDismiss={onDismiss}
			confirmText={buttonText}
			cancelText={t('Cancel')}
			dialogContentProps={dialogContentProps}
		/>
	);
};
